import React from "react";
import { useOutletContext } from "react-router";

import DefaultTheme from "./component/defaultTheme";
import ChicTheme from "./component/chicTheme";
import ModernTheme from "./component/modernTheme";
import CuteTheme from "./component/cuteTheme";
import SimpleTheme from "./component/simpleTheme";


export default function ThemeSelector() {
  const { homepageInfo, theme } = useOutletContext();
  const themes = {
    0: DefaultTheme,
    1: ChicTheme,
    2: ModernTheme,
    3: CuteTheme,
    4: SimpleTheme,
  };

  const Component = themes[theme.toString()] || DefaultTheme;

  return <Component homepageInfo={homepageInfo} />;
}
